import { z } from 'zod';

export const PersonPropsSchema = z.object({
  external_id: z.string().optional(),
  first_name: z.string().optional(),
  last_name: z.string().optional(),
  name: z.string().min(1, 'Name cannot be empty'),
  email: z.union([z.string().email('Invalid email'), z.literal('')]).optional(),
  role_type: z.string().optional(),
  seniority: z.string().optional(),
  geo: z
    .object({
      street: z.string().optional(),
      city: z.string().optional(),
      state: z.string().optional(),
      postal_code: z.string().optional(),
      country: z.string().optional(),
      latitude: z.number().optional(),
      longitude: z.number().optional(),
    })
    .optional(),
  source: z.string().optional(),
  source_raw_data_id: z.string().uuid().optional(),
  user_id: z.string().uuid().optional(),
});

export type PersonProps = z.infer<typeof PersonPropsSchema>;

export const PERSON_NATURAL_KEY_FIELD = 'email';
